import { render, staticRenderFns } from "./LeadFilter.vue?vue&type=template&id=980d9c7a&"
import script from "./LeadFilter.vue?vue&type=script&lang=js&"
export * from "./LeadFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports